var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile-view-page"},[_c('Profile',{attrs:{"id":_vm.$route.params.id},on:{"menuEvent":function($event){_vm.menus.profile = $event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }